var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBoxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7266 31.7539H35.2734V35.2695H24.7266V31.7539Z",
    fill: "#2B4E7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6772 35.2722H38.7891V37.0301C38.7891 38.0014 38.0026 38.7879 37.0312 38.7879H22.9688C21.9974 38.7879 21.2109 38.0014 21.2109 37.0301V35.2722H11.3228C9.04999 35.2722 7.03995 33.8234 6.32034 31.6674L0 12.7031V51.0926C0 54.0003 2.36572 56.366 5.27344 56.366H54.7266C57.6343 56.366 60 54.0003 60 51.0926V12.7045L53.6792 31.6674C52.9601 33.8234 50.95 35.2722 48.6772 35.2722V35.2722Z",
    fill: "#2B4E7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0302 3.62891H22.9677C20.06 3.62891 17.6943 5.99463 17.6943 8.90234V10.6602H3.02344L9.65323 30.5523C9.89355 31.2714 10.5646 31.7539 11.3218 31.7539H21.2099V29.9961C21.2099 29.0247 21.9964 28.2383 22.9677 28.2383H37.0302C38.0016 28.2383 38.7881 29.0247 38.7881 29.9961V31.7539H48.6762C49.4333 31.7539 50.1044 31.2714 50.3448 30.5523L56.975 10.6602H42.3037V8.90234C42.3037 5.99463 39.938 3.62891 37.0302 3.62891V3.62891ZM21.2099 10.6602V8.90234C21.2099 7.93234 21.9977 7.14453 22.9677 7.14453H37.0302C38.0002 7.14453 38.7881 7.93234 38.7881 8.90234V10.6602H21.2099Z",
    fill: "#2B4E7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBoxIcon);
export default __webpack_public_path__ + "static/media/blueBoxIcon.0ce15ce587762d6dabdcf4b0b69cfcf8.svg";
export { ForwardRef as ReactComponent };